import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {MenuBuilderShortcutModel} from "@/core/model/main.model";

interface ShortcutState {
  item: MenuBuilderShortcutModel | null;
  hasSetting: boolean;
}

const initialState: ShortcutState = {
  item: null,
  hasSetting: false
};

const shortcutSlice = createSlice({
  name: 'shortcut',
  initialState,
  reducers: {
    shortcutState: (state, action: PayloadAction<{ item:MenuBuilderShortcutModel|null,hasSetting:boolean }>) => {
      state.item = action.payload.item;
      state.hasSetting= action.payload.hasSetting;
    },
  },
});

export const { shortcutState } = shortcutSlice.actions;
export default shortcutSlice.reducer;
